// import FMaterialMap from "@/models/f-material-map";
import FMaterial from "@/models/f-material";

export const materialModule = {
    namespace: true,
    state: {
        itemModifiedMaterial: new FMaterial(),
        formModeMaterial: '',
        /**
         * Tabel Detil Material Map
         */
        // itemFMaterialMap: new FMaterialMap(),
        // listFMaterialMap: [],
        /**
         * Isi dari Tabel Detil Map
         */
        listFMaterial: [],
    },
    actions:{
        updateItemModifiedMaterial({commit}, payload) {
            commit('mutateItemModifiedMaterial', payload)
        },
        updateFormModeMaterial({commit}, payload) {
            commit('mutateFormModeMaterial', payload)
        },
        // updateItemFMaterialMap({commit}, payload){
        //     commit('mutateItemFMaterialMap', payload)
        // },
        // updateListFMaterialMap( {commit}, payload){
        //     commit('mutateListFMaterialMap', payload)
        // },
        //
        updateListFMaterial({commit}, payload){
            commit('mutateListFMaterial', payload)
        },
    },
    mutations:{
        mutateItemModifiedMaterial(state, payLoad) {
          state.itemModifiedMaterial = payLoad
        },
        mutateFormModeMaterial(state, payLoad) {
            state.formModeMaterial = payLoad
        },
        // mutateItemFMaterialMap(state, payload){
        //     state.itemFMaterialMap = payload
        // },
        // mutateListFMaterialMap(state, payload){
        //     state.listFMaterialMap = payload
        // },
        mutateListFMaterial(state, payload){
            state.listFMaterial = payload
        },
    }

}